// trackPageview.ts already handles the actual API call — this just wires
// it to route changes. Key fix: this component must be rendered INSIDE
// <BrowserRouter>, not in the component that creates the Router.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../trackPageview';

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageview();
  }, [location.pathname]);

  return null;
}

export default RouteChangeTracker;
